import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getApi } from "../../../services/api/globalApi";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";
import { useSelector } from "react-redux";

const { forwardRef, useRef, useImperativeHandle } = React;

const VendorTypeSelect = forwardRef(({ oldVendor, onChange, label }, ref) => {
  const { utils } = useSelector(utilsState);

  const [vendorOption, setVendorOption] = useState([]);
  const [selectedVendors, setSelectedVendor] = useState([]);

  useImperativeHandle(ref, () => ({
    afterSubmit() {
      setSelectedVendor([]);
    },
  }));

  useEffect(() => {
    if (utils?.VENDOR_TYPE_VALUES?.length) {
      let newVendor = [];
      utils?.VENDOR_TYPE_VALUES?.map((item) =>
        newVendor.push({
          value: item.value,
          label: item.name,
        })
      );
      setVendorOption(newVendor);
    }
  }, [utils]);

  function handleVendors(data) {
    setSelectedVendor(data);
    const newData = data.map((item) => {
      return item.value;
    });
    onChange(newData || []);
  }

  useEffect(() => {
    if (oldVendor?.length > 0 && utils?.VENDOR_TYPE_VALUES?.length) {
      let selectedVendors = [];
      for (let i = 0; i < oldVendor?.length; i++) {
        let isExist = utils?.VENDOR_TYPE_VALUES.filter((item) => {
          return item.value == oldVendor[i];
        });
        selectedVendors.push({
          value: isExist[0]?.value,
          label: isExist[0]?.name,
        });
        console.log(isExist);
      }
      console.log(selectedVendors);
      setSelectedVendor(selectedVendors);
    }
  }, [oldVendor, utils]);

  return (
    <div>
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {label}
      </label>
      <Select
        classNamePrefix="admin-select"
        isRtl
        className=""
        options={vendorOption}
        placeholder="انتخاب نوع غرفه"
        value={selectedVendors}
        onChange={handleVendors}
        isSearchable={true}
        isMulti
      />
    </div>
  );
});

export default VendorTypeSelect;
